export default __webpack_public_path__ + "static/logo-526d9caa37a159b2063ac2e0f5a8f9aa.png";